import { render, staticRenderFns } from "./AdminOverview.vue?vue&type=template&id=36720b65&scoped=true&"
import script from "./AdminOverview.vue?vue&type=script&lang=js&"
export * from "./AdminOverview.vue?vue&type=script&lang=js&"
import style0 from "./AdminOverview.vue?vue&type=style&index=0&id=36720b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36720b65",
  null
  
)

export default component.exports